import { defineStore } from 'pinia'
import { ref } from 'vue'

export type CookieType = 'essential' | 'preferences' | 'tracking'

interface CookieConsent {
  essential: boolean
  preferences: boolean
  tracking: boolean
}

export const useCookieStore = defineStore('cookie', () => {
  const cookieConsent = ref<CookieConsent>({
    essential: true, // Siempre true ya que son imprescindibles
    preferences: false,
    tracking: false,
  })

  const hasShownBanner = ref(false)

  const initializeCookies = () => {
    const savedConsent = localStorage.getItem('cookieConsent')
    if (savedConsent) {
      cookieConsent.value = JSON.parse(savedConsent)
      hasShownBanner.value = true
    }
  }

  const saveCookiePreferences = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(cookieConsent.value))
    hasShownBanner.value = true
  }

  const updateCookieConsent = (type: CookieType, value: boolean) => {
    if (type === 'essential') return // No permitir desactivar cookies esenciales
    cookieConsent.value[type] = value
    saveCookiePreferences()
  }

  const acceptAll = () => {
    cookieConsent.value = {
      essential: true,
      preferences: true,
      tracking: true,
    }
    saveCookiePreferences()
  }

  const rejectAll = () => {
    cookieConsent.value = {
      essential: true,
      preferences: false,
      tracking: false,
    }
    saveCookiePreferences()
  }

  return {
    cookieConsent,
    hasShownBanner,
    initializeCookies,
    updateCookieConsent,
    acceptAll,
    rejectAll,
  }
})
